import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { dirForLang, normalizeLang } from "../i18n";
import {
  PHASE1_GATES,
  getPhaseOneEntryQuestion,
  getPhaseOneGateLabel,
} from "../phase1/config";
import "../phase1/phase1Entry.css";

const COPY = {
  he: {
    brand: "InnerVoice",
  },
  en: {
    brand: "InnerVoice",
  },
  es: {
    brand: "InnerVoice",
  },
};

function getCopy(lang) {
  return COPY[lang] || COPY.he;
}

export default function Phase1GateSelection() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const lang = normalizeLang(params.get("lang") || "he");
  const dir = dirForLang(lang);
  const copy = getCopy(lang);
  const gender = String(user?.gender || "").toLowerCase();

  useEffect(() => {
    try {
      localStorage.setItem("innervoice_lang", lang);
    } catch {
      // ignore
    }
  }, [lang]);

  return (
    <div className="phase1-shell" dir={dir}>
      <div className="phase1-card">
        <p className="phase1-brand">{copy.brand}</p>
        <h1 className="phase1-title">{getPhaseOneEntryQuestion(lang, gender)}</h1>
        <div className="phase1-gates">
          {PHASE1_GATES.map((gate) => (
            <button
              key={gate.key}
              type="button"
              className="phase1-gate"
              onClick={() => navigate(`/phase1/ready?lang=${lang}&gate=${encodeURIComponent(gate.key)}`)}
            >
              <span>{getPhaseOneGateLabel(gate.key, lang)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
